import React from 'react'
import homeImage from '../assets/home.jpg'
import Typewriter from "typewriter-effect"
import { Link } from 'react-router-dom'
import "../components/AniButton.css"


const Home = ({isLoggedIn}) => {

  return (
    <div className='flex h-screen w-screen justify-center items-center text-white'>
      {/* <div className='md:relative xl:relative hidden h-screen w-screen'>
      </div> */}
        <img src={homeImage}
          className='opacity-30 md:relative xl:relative md:flex xl:flex hidden h-screen w-screen'
        />

      
      {/* Right section */}
      
        <div className='absolute md:top-40 md:right-80 md:mt-0 mt-48 w-80'>  
          <h1 className="flex flex-col items-start gap-y-4 text-xl sm:text-3xl font-bold md:text-4xl xl:text-6xl aos-init aos-animate">
          <span>Learn</span>
          <span className='text-blue-400'>
            <Typewriter
                  options={{
                    strings: ['Development', 'Business','Design','Lifestyle'],
                    autoStart: true,
                    loop: true,
                  }}
                />
          </span>
          </h1>

          <p className='mt-10 font-bold lg:text-3xl text-yellow-500 md:w-[120%] w-[90%]'>
            We help you to upgrade your skills to the next level and you became industry ready after completion of our courses.
          </p>
          
          <Link to='/courses'>
            <button className='expbtn'>
              Explore Now
            </button>
          </Link>       
        </div>
        
        {/* left section */}
        <div className='absolute w-6/12 h-20 xl:flex md:hidden md:w-5/12 hidden gap-x-4 justify-center items-center p-5 md:bottom-40 md:left-10 bottom-10 left-34'>

        <Link to='/articles'>
            <div className=' bg-white text-red-600 text-4xl font-bold bg-opacity-40 py-5 px-10 w-64 min-w-full text-center'>
            Read</div>
        </Link>

        <Link to='/courses'> 
            <div className='bg-white text-blue-800 text-4xl font-bold bg-opacity-40 py-5 px-10 w-64 min-w-full text-center'>Watch</div>
        </Link>

        </div>
      
    </div>
  )
}

export default Home
